module.exports = __webpack_public_path__ + "img/productionSlide1.2b99d430.jpg";